/**
 * Where Spectate's uptime checks come from. The single source for the IP
 * addresses page and `/ip-addresses.txt` (written at build time by
 * `scripts/postprocess-build.mjs`). Keep in line with the checker servers
 * (docs/go-live.md, "Where it runs") and marketing's acceptable use policy.
 */
export type CheckerRegion = {
  /** The monitor location value in the API and dashboard. */
  location: string;
  name: string;
  ipv4: string[];
  ipv6: string[];
};

export const checkerUserAgent = "Spectate/1.0 (+https://docs.spectate.net/faq/uptime-monitor-bot)";

export const checkerRegions: CheckerRegion[] = [
  { location: "eu", name: "Europe", ipv4: ["94.237.7.128"], ipv6: ["2a04:3544:1000:1510:8c5d:3bff:fed0:16e6"] },
  { location: "us", name: "North America", ipv4: ["85.9.192.172"], ipv6: ["2605:7380:8000:1000:8c5d:3bff:fed0:18a9"] },
  { location: "as", name: "Asia", ipv4: ["95.111.197.76"], ipv6: ["2a04:3543:1000:2310:8c5d:3bff:fed0:66e"] },
  { location: "oc", name: "Oceania", ipv4: ["95.111.223.64"], ipv6: ["2a04:3546:8000:1000:8c5d:3bff:fed0:54f9"] },
];

export const ipAddressesText = (): string =>
  checkerRegions
    .map((region) => [`# ${region.name}`, ...region.ipv4, ...region.ipv6].join("\n"))
    .join("\n\n") + "\n";
